import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { LicenseEntity, LicenseEntityJson } from "@youm-front/license/domain";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class LicenseService {
  constructor(private readonly apiService: ApiService) {}

  loadLicense(): Observable<LicenseEntity> {
    return this.apiService
      .get<{ license: LicenseEntityJson }>("license")
      .pipe(map((_) => new LicenseEntity(_.license)));
  }
}
